import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {NgSelectComponent} from '@ng-select/ng-select';
import {FormService} from '../../services/FormService';
import {UserInformationFields} from '../../constants/user-information-fields';
import {Select} from 'primeng/select';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-selected-employee-information',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    NgSelectComponent,
    Select
  ],
  template: `
    <div class="form-row">
      <label></label>
      <div>
        <div class="text-danger">
          This field will only be visible in the FOH and MNG app, and not visible in the BOSS app!!!
        </div>
      </div>
    </div>
    <div class="form-row flex-align-center">
      <label>{{ Yii.t('app', 'Related "Employee Picker"') }}
        <span class="text-danger">*</span>
      </label>
      <div>
        <p-select
          [options]="getEmployeeOptions()"
          [(ngModel)]="field.related_employee_picker_id"
          optionLabel="field_title"
          optionValue="field_id"
          placeholder="Select..."
          />
      </div>
    </div>
    <div class="form-row">
      <label>{{ Yii.t('app', 'Source Field') }}</label>
      <div>
        <ng-select
          style="width: 480px"
          [hideSelected]="true"
          appendTo="body"
          [items]="listOfPredefinedValues"
          [multiple]="true"
          bindLabel="tag"
          bindValue="key"
          placeholder="Select..."
          [(ngModel)]="field.source_field">
        </ng-select>
      </div>
    </div>
  `
})
export class FieldSelectedEmployeeInformation {
  Yii = Yii;
  @Input() field: any;

  public listOfPredefinedValues = UserInformationFields;

  constructor(public fsvc: FormService) {
  }

  public getEmployeeOptions(): any[] {
    return this.fsvc.form?.form_fields?.filter(
      (field: any) => field.field_type === 'employees'
    ).map(
      (f:any) => {
        const ff = {...f}
        ff.field_title = f.field_title.trim() !== '' ? f.field_title : 'Field-' + (f.field_id + 1)
        return ff;
      }
    ) ?? [];
  }
}
